<template>
    <div class="ttn_content">
        <div class="row mb-5">
            <div class="col-12">
                <section>
                    <h1 class="page-title">cart</h1>
                    <notifications></notifications>
                    <cart-list-section v-if="$store.getters.cartItems.length"></cart-list-section>
                    <div class="notices-wrapper" v-if="this.sharedOrderCount >= 1 && this.hashshared && !$store.getters.cartItems.length">
                        <div class="notice-message info" role="alert">
                            <i class="far fa-window-maximize newIcon"></i>
                            This Cart Has Been Purchased and is No Longer Available
                        </div>
                    </div>
                    <div class="notices-wrapper" v-else-if="this.sharedOrderCount == 0 && this.hashshared && !$store.getters.cartItems.length">
                        <div class="notice-message info" role="alert">
                            <i class="far fa-window-maximize newIcon"></i>
                            This Cart is No Longer Available. Please&nbsp;<a href="/contact" style="color: #9daca1;text-decoration: underline;transition: all 0.3s ease;line-height: normal; margin: 0;text-transform: capitalize;">Contact Us</a>&nbsp;if You Feel You’ve Reached This Message in Error
                        </div>
                    </div>
                    <div class="notices-wrapper" v-else-if="!$store.getters.cartItems.length">
                        <div class="notice-message info" role="alert">
                            <i class="far fa-window-maximize newIcon"></i>
                            Your cart is currently empty.
                        </div>
                    </div>
                    <p class="return-to-shop" v-if="!$store.getters.cartItems.length">
                        <a class="button wc-backward" href="/ceiling-wall-floor-treatment-products/">
                            Return to shop
                        </a>
                    </p>
                </section>
            </div>
        </div>
        <div class="row total_row">
            <div v-if="cartLinkedProducts.length" class="col-md-6">
                <section>
                    <h2 class="page-second-title cart_interested_sec">You may be interested in...</h2>
                    <cart-product-list-item/>
                </section>
            </div>
            <div class="col-md-6 ml-auto">
                <section :class="{loader: $store.getters.loading}" v-if="$store.getters.cartItems.length">
                    <h2 class="page-second-title">Cart totals</h2>
                    <cart-totals-section></cart-totals-section>
                    <div class="proceed-to-checkout mb-5">
                        <button v-on:click="processCheckout" class="checkout-button" :class="{disabled: isCheckoutDisabled}">Proceed to checkout</button>
<!--                        <div class="checkout-buttons-div" v-if="!isCheckoutDisabled">-->
<!--                            <div class="checkout-buttons__separator">— OR —</div>-->
<!--                            <paypal-button></paypal-button>-->
<!--                        </div>-->

<!--                        <div class="checkout-info btn-text">*Must Calculate Shipping Prior to Checkout</div>-->
                        <button class="cxecrt-cart-page-btn tn_btn_light w-100" type="button" data-toggle="modal" data-target="#shareCartModal">Save &amp; Share Cart</button>
                    </div>
                    <img loading="lazy" src="/images/badge/Trust-Badges-Graphic.png" alt="Trust Badges" class="trust-badges-img">
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import CartListSection from "./CartListSection";
import CartTotalsSection from "./CartTotalsSection";
// import PaypalButton from "../PaypalButton";
import {mapActions, mapGetters} from "vuex";
import CartProductListItem from "./CartProductListItem";
export default {
    name: 'cart-content',
    props: ['propAppendurl', 'propSharedcarthash', 'propHashshared','propSharedordercount'],
    components: {CartProductListItem, CartTotalsSection, CartListSection},
    data() {
        return{
            appendurl: this.propAppendurl,
            sharedcarthash: this.propSharedcarthash,
            hashshared: this.propHashshared,
            sharedOrderCount: this.propSharedordercount,
            dataLayerCount: 0,
        }
    },
    methods: {
        ...mapActions(['saveCart', 'addNote', 'emptyNotes','linkedProducts','cartMinQtyNote','checkCartItems']),
        processCheckout() {

            this.cartMinQtyNote().then(res => {

                if(res.status == 'ok')
                {
                    if(this.isCheckoutDisabled) {
                        this.emptyNotes()
                        this.addNote({item: {message: 'Please calculate your shipping cost', type: 'error'}, target: 'shipping', scrollTo: false})
                        return
                    }

                    const items = this.cartItems.filter(i => {
                        const product = this.getProduct(i.id);
                        return product && product.allow_combination;
                    });
                    let itemsQty = 0;
                    let enableFUnc = 0;
                    if (items.length) {
                        for (let i = 0; i < items.length; i++) {
                            itemsQty += isNaN(items[i].quantity) ? 0 : Number(items[i].quantity);
                            enableFUnc += ( items[i].enable_functionality_for_admin && this.$store.getters.auth ) || !this.$store.getters.auth ? 1 : 0;
                        }

                        if (enableFUnc && itemsQty < this.minOrderQuantity && this.$store.getters.cartType != 1) {
                            this.emptyNotes()
                            this.addNote({item: {
                                    message: `The Minimum Order Quantity (MOQ) for this cart is ${this.minOrderQuantity}. In order to Proceed to Checkout please either, increase the quantity of the Item already in your Cart to at least ${this.minOrderQuantity}, or add additional variations of the same Item (i.e. different size, texture, color etc.) so that the sum of the variations in your Cart is at least ${this.minOrderQuantity}.`,
                                    type: 'error',
                                }
                            })
                            return;
                        }
                    }
                    this.emptyNotes()
                    document.location.href = '/checkout/'
                }

            });
        },
        getProduct(itemId) {
            return this.$store.state.app.products.find(i => i.id === itemId)
        }
    },
    mounted() {
        this.$store.state.cart.appendurl = this.appendurl
        this.$store.state.cart.sharedCartHash = this.sharedcarthash ? this.sharedcarthash : this.$store.state.cart.sharedCartHash
        this.saveCart({page: 'cart'})
        this.linkedProducts(4)
        this.cartMinQtyNote()
    },
    updated()
    {
        this.checkCartItems()
        window.dataLayer = window.dataLayer || [];

        // if(this.$store.state.cart.items.length)
        // {
        //     window.dataLayer = {...window.dataLayer,...this.$store.getters.cartDefaultDataLayer};
        // }
        // else
        // {
        //     window.dataLayer = {...window.dataLayer,...this.$store.getters.cartDefaultDataLayer};
        // }
        if(this.dataLayerCount == 0 && this.$store.getters.cartDefaultDataLayer[0].ecommerce.cart.length > 0)
        {
            window.dataLayer.push(this.$store.getters.cartDefaultDataLayer[0]);
            window.dataLayer.push(this.$store.getters.cartDefaultDataLayer[1]);

            this.dataLayerCount = 1;
        }

    },
    computed: {
        ...mapGetters(['cartItems', 'cartLinkedProducts']),
        isCheckoutDisabled() {
            return !this.$store.getters.isShippingCalculated
        },
        minOrderQuantity() {
            return this.$store.getters.minOrderQuantity
        }
    }
}
</script>
<style scoped>
.notices-wrapper .notice-message{
    padding: 1em 2em 1em 3.5em;
    margin: 0 0 1.2em;
    position: relative;
    background-color: #f7f6f7;
    color: #515151;
    list-style: none outside;
    width: auto;
    word-wrap: break-word;
    border-top: 3px solid;
}

button.disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.notices-wrapper .notice-message .button{
    float: right;
    color: #595959;
    background-color: #f2f2f2;
    font-size: 100%;
    margin: 0;
    line-height: 1;
    cursor: pointer;
    position: relative;
    text-decoration: none;
    overflow: visible;
    padding: 0.618em 1em;
    font-weight: 700;
    border-radius: 3px;
    left: auto;
    border: 0;
    display: inline-block;
    background-image: none;
    box-shadow: none;
    text-shadow: none;
}

.notices-wrapper .notice-message.success{
    border-top-color: #8fae1b;
}
.notices-wrapper .notice-message.error{
    border-top-color: #a46497;
}
.notices-wrapper .notice-message.info{
    border-top-color: #1e85be;
}

</style>
